import {merge} from '@shared/helpers/object'

import {getResultInfo} from '@web/actions/result'
import {createNaverMembershipState} from '@web/slices/purchaser/slice'
import makeSlice from '@web/slices/purchaser/sliceMaker'

const slice = makeSlice({
    extraReducers: (builder) => {
        builder.addCase(getResultInfo.fulfilled, (state, {payload}) => {
            const {
                purchaser: {alarmType, name},
                naverMembership,
            } = payload
            state.alarmType = alarmType
            state.name = name ?? ''
            // 주문서의 맴버쉽 정보를 초기화한후, 주문완료 정보를 반영합니다.
            state.naverMembership = merge(createNaverMembershipState(), naverMembership)
        })
    },
})

export default slice.reducer
